import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioAdminCreate } from '../../../models/auth.model';
import { FuncionarioCargoProducao } from '../../../models/cadastro.model';
import { ErrorModel } from '../../../models/error.model';
import { AuthService } from '../../../services/auth.service';
import { FuncionarioModal } from '../../modal/funcionario-modal/funcionario-modal';

@Component({
  selector: 'app-usuario-admin-manutencao',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FuncionarioModal],
  templateUrl: './usuario-admin-manutencao.component.html',
  styleUrl: './usuario-admin-manutencao.component.css'
})
export class UsuarioAdminManutencaoComponent implements OnInit {
  usuarioForm: FormGroup;
  isLoading = false;
  modoEdicao = false;
  usuarioId: number | null = null;

  modalFuncionarioAberto = false;
  nomeFuncionarioSelecionado = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.usuarioForm = this.fb.group({
      id: [0],
      nomeUsuario: ['', [Validators.required]],
      nomeCompleto: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      ativo: [true],
      secret: ['', [Validators.required]],
      idFuncionario: [null, [Validators.required]]
    });
  }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.modoEdicao = true;
      this.usuarioId = Number(idParam);
      this.usuarioForm.get('secret')?.clearValidators();
      this.usuarioForm.get('secret')?.updateValueAndValidity();
      this.carregarUsuario(this.usuarioId);
    }
  }

  private carregarUsuario(id: number): void {
    this.isLoading = true;
    this.authService.getUsuarios().subscribe({
      next: (usuarios) => {
        this.isLoading = false;
        const usuario = usuarios.find(u => u.id === id);
        if (!usuario) {
          this.toastr.error('Usuário não encontrado.');
          this.voltar();
          return;
        }
        this.usuarioForm.patchValue({ ...usuario, secret: '' });
      },
      error: (error) => {
        this.isLoading = false;
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar usuário.');
      }
    });
  }

  onFuncionarioSelecionado(f: FuncionarioCargoProducao | undefined): void {
    this.modalFuncionarioAberto = false;
    if (f) {
      const id = f.idFuncionario ?? f.id ?? f.codigo ?? null;
      this.usuarioForm.patchValue({ idFuncionario: id });
      this.usuarioForm.get('idFuncionario')?.markAsTouched();
      this.nomeFuncionarioSelecionado = `${f.nome} - ${f.cargo}`;
    }
  }

  salvar(): void {
    if (this.usuarioForm.invalid) {
      this.usuarioForm.markAllAsTouched();
      this.toastr.warning('Preencha corretamente os campos obrigatórios.');
      return;
    }

    this.isLoading = true;
    const formValue = this.usuarioForm.getRawValue();
    const payload: UsuarioAdminCreate = this.modoEdicao && !formValue.secret
      ? (({ secret, ...rest }) => rest)(formValue)
      : formValue;

    if (this.modoEdicao && this.usuarioId) {
      this.authService.updateUsuarioAdmin(this.usuarioId, payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.toastr.success('Usuário atualizado com sucesso.');
          this.voltar();
        },
        error: (error) => {
          this.isLoading = false;
          const erro: ErrorModel = error.error;
          this.toastr.error(erro?.message || 'Erro ao atualizar usuário.');
        }
      });
    } else {
      this.authService.createUsuario(payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.toastr.success('Usuário criado com sucesso.');
          this.voltar();
        },
        error: (error) => {
          this.isLoading = false;
          const erro: ErrorModel = error.error;
          this.toastr.error(erro?.message || 'Erro ao criar usuário.');
        }
      });
    }
  }

  voltar(): void {
    this.router.navigate(['/home', 'sistema-permissoes']);
  }
}
